export default function setFocus(className) {
  const element = document.querySelector(`.${className}`);
  if (element) {
    element.focus();
  }
}
